"use client";

import { useMutation } from "@tanstack/react-query";

import type { RegisterRequest } from "@/shared/api/services/authService";
import { useAuth } from "@/shared/auth/hooks";

import { useAuthService } from "@/features/auth/hooks/useAuthService";

/**
 * 이메일 로그인 뮤테이션
 */
export function useEmailLogin() {
  const { login } = useAuth();

  return useMutation({
    mutationFn: async ({ email, password }: { email: string; password: string }) => {
      await login(email, password);
    },
  });
}

/**
 * 회원가입 뮤테이션
 */
export function useRegister() {
  const authService = useAuthService();

  return useMutation({
    mutationFn: async (data: RegisterRequest) => {
      return authService.register(data);
    },
  });
}

/**
 * 사업자등록증 첨부파일 업로드 뮤테이션
 */
export function useUploadAttachment() {
  const authService = useAuthService();

  return useMutation({
    mutationFn: async ({ file, idUser }: { file: File; idUser: string }) => {
      return authService.uploadAttachment(file, idUser);
    },
  });
}
